import WindowsListeningTentacleCallout from "./WindowsListeningTentacleCallout";
import LinuxListeningTentacleCallout from "./LinuxListeningTentacleCallout";
import WindowsPollingTentacleCallout from "./WindowsPollingTentacleCallout";
import LinuxPollingTentacleCallout from "./LinuxPollingTentacleCallout";

export { WindowsListeningTentacleCallout, LinuxListeningTentacleCallout, WindowsPollingTentacleCallout, LinuxPollingTentacleCallout };
